var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support-team"},[_c('div',{staticClass:"page-container"},[_c('PageTitle',{attrs:{"ch":"超偶特攻隊","en":"Volunteer"}}),_vm._v(" "),_c('BannerSplit2SupportTeam'),_vm._v(" "),_c('iframe',{attrs:{"src":"https://goo.gl/UCnbba","frameborder":"0"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e6b138a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/support/support_club.vue
// module id = null
// module chunks = 